module.exports = {["template-constructor-control-text_align"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="icon" data-alt="Align" data-alt-pos="left" data-alt-offset="9"></div>\n\n	<div class="panel">\n		<div class="left" title="Left Align"></div>\n		<div class="center" title="Center"></div>\n		<div class="right" title="Right Align"></div>\n		<div class="justify" title="Justify"></div>\n	</div>\n';
}
return __p;
},}